module.exports = __webpack_public_path__ + "static/img/client.8669e2c6.svg";